import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { CasesEffects, fromCases } from "./state/cases";

/**
 * Registers the `cases` feature slice + effects.
 *
 * Imported ONCE, eagerly, by TelespotShellModule: the slice is shared by
 * chat-box, reports, the workspaces cases list and acquisition's case-detail
 * effects, so it must exist from bootstrap. Do NOT import it anywhere else —
 * NgRx does not dedupe effect classes across injectors, so a second
 * registration (e.g. in a lazy feature module or in
 * TelespotReportsDataAccessModule) makes every CasesEffects side effect run
 * once more per dispatch (double saves, double fetches).
 */
@NgModule({
  imports: [
    StoreModule.forFeature(fromCases.CASES_FEATURE_KEY, fromCases.reducer),
    EffectsModule.forFeature([CasesEffects]),
  ],
})
export class CasesStateModule {}
